import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-tone", "data-pos", "data-disabled"]
const _hoisted_2 = {
  key: 0,
  class: "chip-icon"
}

import { computed } from 'vue'
import { game } from '../../game/init'


export default /*@__PURE__*/_defineComponent({
  __name: 'Chip',
  props: {
    tone: { type: String, required: false },
    icon: { type: String, required: false },
    item: { type: String, required: false },
    count: { type: Number, required: false },
    from: { type: Boolean, required: false },
    to: { type: Boolean, required: false },
    tail: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false }
  },
  setup(__props: any) {

const props = __props

const pos = computed(() =>
  props.from ? 'from' : props.to ? 'to' : props.tail ? 'tail' : undefined,
)

const itemDisplay = computed(() => {
  if (!props.item) return ''
  const emoji = (game.data.items as any)[props.item]?.display?.emoji ?? props.item
  const count = props.count ?? 1
  return count === 1 ? emoji : `${count}×${emoji}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "chip",
    "data-tone": __props.tone || undefined,
    "data-pos": pos.value,
    "data-disabled": __props.disabled || undefined
  }, [
    (__props.item)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(itemDisplay.value), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.icon), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "default")
        ], 64 /* STABLE_FRAGMENT */))
  ], 8 /* PROPS */, _hoisted_1))
}
}

})